import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { devicesApi } from '~/apis/devicesApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'
import { useCheckRole } from '~/hooks/useCheckRole'
import { ApplicationRoutes } from '~/types/RoutingTypes'

import { DevicesListPage } from '@mangovoice/devices-ui'

export const DevicesPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { pbxId, userRoles } = useUserState({ canAutoRefresh: false })
  const checkRole = useCheckRole()
  const safePbxId = pbxId ?? 0
  const isInternalUser = Boolean(userRoles?.is_staff || userRoles?.is_superuser)

  if (!safePbxId) return null

  return (
    <DevicesListPage
      api={devicesApi}
      pbxId={safePbxId}
      navigate={navigate}
      toast={toaster}
      actionsEnabled={checkRole('admin')}
      canCreate={isInternalUser}
      isStaff={isInternalUser}
      getEditRoute={(id) =>
        ApplicationRoutes.DEVICE_EDIT.replace(':deviceId', String(id))
      }
      addRoute={ApplicationRoutes.DEVICE_NEW}
      addButtonColorPalette="brand"
      t={t}
    />
  )
}
